module.exports = __webpack_public_path__ + "static/img/rosepowder1.3fc08221.png";